module.exports = __webpack_public_path__ + "media/images/niq-logo-square-248732f45a8e3e8b939eb886c98492f0.png";